var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyboardArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 36C23.5217 36 23.0732 35.9268 22.6547 35.7805C22.2362 35.6342 21.8475 35.3855 21.4888 35.0344L4.98655 18.8817C4.32885 18.2379 4 17.4186 4 16.4237C4 15.4288 4.32885 14.6094 4.98655 13.9656C5.64425 13.3219 6.48132 13 7.49776 13C8.5142 13 9.35127 13.3219 10.009 13.9656L24 27.6603L37.991 13.9656C38.6487 13.3219 39.4858 13 40.5022 13C41.5187 13 42.3558 13.3219 43.0135 13.9656C43.6712 14.6094 44 15.4288 44 16.4237C44 17.4186 43.6712 18.2379 43.0135 18.8817L26.5112 35.0344C26.1525 35.3855 25.7638 35.6342 25.3453 35.7805C24.9268 35.9268 24.4783 36 24 36Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowDown);
export default __webpack_public_path__ + "static/media/keyboard_arrow_down.0fe7c37d.svg";
export { ForwardRef as ReactComponent };